import React, { useState, useEffect } from 'react';
import ProductServices from '../../../services/ProductServices';
import { Modal, Button, Container, Row, Col, Table, Spinner } from 'react-bootstrap';
import Swal from "sweetalert2";

const ItemsModal = ({ show, item, handleClose }) => {
  const [inventoryData, setInventoryData] = useState([]);
  const [loading, setLoading] = useState(false); // 🟡 Track loading


  useEffect(() => {
    const fetchInventory = async () => {
      if (item?.inventory?.masterItem?._id) {
        setLoading(true); // start loading
        try {
          const response = await ProductServices.getallInventoryByMasterItem(item.inventory.masterItem._id);
          setInventoryData(response.data || []);
        } catch (error) {
          console.error("Error fetching inventory:", error);
        } finally {
          setLoading(false); // done loading
        }
      }
    };

    if (show && item?.inventory?.masterItem?._id) {
      fetchInventory();
    }
  }, [show, item]);

  return (
    <Modal className="fade" show={show} onHide={handleClose} size="xl">
      <Modal.Header>
        <Modal.Title><i className="fas fa-eye me-2"></i>Available Stocks</Modal.Title>
        <Button variant="" className="btn-close" onClick={handleClose}></Button>
      </Modal.Header>

      <Modal.Body>
        <Container>
          {loading ? (
            <div className="text-center my-4">
              <Spinner animation="border" variant="primary" />
              <div className="mt-2">Loading stock data...</div>
            </div>
          ) : inventoryData.length > 0 ? (
            <>
              <Row className="mb-3">
                <Col>
                  <strong>Total Stores with Stock:</strong> {inventoryData.length}
                </Col>
              </Row>
              <Row>
                <Col>
                  <Table striped bordered hover responsive size="sm">
                    <thead className="table-dark">
                      <tr>
                        <th>#</th>
                        <th>Part No.</th>
                        <th>Description</th>
                        <th>Store Name</th>
                        <th>Location</th>
                        <th>Store Code</th>
                        <th>Current Stock</th>
                        <th>Unit</th>
                      </tr>
                    </thead>
                    <tbody>
                      {inventoryData.map((inv, index) => (
                        <tr key={inv._id}>
                          <td>{index + 1}</td>
                          <td>{item?.inventory?.masterItem?.partNo}</td>
                          <td>{item?.inventory?.masterItem?.description}</td>
                          <td>{inv.store?.name || 'N/A'}</td>
                          <td>{inv.store?.location || 'N/A'}</td>
                          <td>{inv.store?.storeCode || 'N/A'}</td>
                          <td>{inv.currentStock}</td>
                          <td>{item?.inventory?.masterItem?.unit?.name}</td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                </Col>
              </Row>
            </>
          ) : (
            <Row>
              <Col>
                <div className="text-center text-muted">No stock available for this item.</div>
              </Col>
            </Row>
          )}
        </Container>
      </Modal.Body>

      <Modal.Footer>
        <Button variant="danger light" onClick={handleClose}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default React.memo(ItemsModal);
